import { AText, Box } from '@alf/uikit';
import useLiveEventState from '../../../../hooks/useLiveEventState';
import { useEventField } from '../../../../store';
import EventStateLabel from './components/EventStateLabel';
import EventStateTimer from './components/EventStateTimer';

import styles from './index.module.css';

const EventState = ({ eventId }) => {
  const isCachedEvent = useEventField(eventId, 'isCachedEvent');
  const { emptyStateText, labelText, eventTime } = useLiveEventState(
    eventId,
    isCachedEvent
  );

  return (
    <Box padding="xs 0 xs s" align="center" className={styles.container}>
      <EventStateTimer eventId={eventId} emptyStateText={emptyStateText} />
      <AText className={styles.separator} size="s" breed="B" color="line_txt_1">
        |
      </AText>
      <EventStateLabel
        eventId={eventId}
        labelText={labelText}
        eventTime={eventTime}
      />
    </Box>
  );
};

export default EventState;
